const { __ } = wp.i18n
import { plural } from '../modules/functions'
import Scrambler from 'scrambling-letters'
import mixitup from 'mixitup'

class DedicNew {
  constructor() {
    this.catalog = document.querySelector('.dedic-products__list')

    if (!this.catalog) return false

    this.dedicItems = document.querySelectorAll('.dedic-card')

    this.selects = document.querySelectorAll('.dedic-card__slot')

    this.currencySwitcher = document.querySelector('.currency-toggle input')

    window.addEventListener('pageshow', this.init.bind(this))

    this.init()
    this.events()
    this.sort()

  }

  init() {
    this.initTotalPrices()
    this.calcPricesDifference()
    this.dedicItems.forEach(dedic => this.renderCpuParams(dedic))
    this.setHeaderSummary()
  }

  events() {
    this.currencySwitcher?.addEventListener('change',
      this.calcPricesDifference.bind(this))
    this.catalog?.addEventListener('click', this.showMore.bind(this))
    this.selects.forEach(select => {
      select.addEventListener('change', this.calcPricesDifference.bind(this))
      select.addEventListener('change', this.totalPriceHandler.bind(this))
      select.addEventListener('change', this.setHeaderSummary.bind(this))
      if (select.dataset.name === 'cpu') {
        const dedic = select.closest('.dedic-card')
        select.addEventListener('change',
          this.renderCpuParams.bind(this, dedic))
      }
    })
  }

  renderCpuParams(dedic) {
    const dedicID = dedic.dataset.id
    const selectCpuEl = dedic.querySelector('[data-name="cpu"]')
    if (!selectCpuEl.children.length) return false
    const resultParamsEl = dedic.querySelector('.dedic-card__result-params')
    const selectedId = selectCpuEl.selectedIndex
    const currentCPU = JSON.parse(selectCpuEl.options[selectedId].value)

    const cores = currentCPU.cores
      ? `${currentCPU.cores} ${plural(currentCPU.cores,
        [__('ядро', 'atlex'), __('ядра', 'atlex'), __('ядер', 'atlex')])}`
      : ''
    const frequency = currentCPU.frequency
      ? `, ${currentCPU.frequency}${__('ГГц', 'atlex')}`
      : ''
    const benchmark = currentCPU.benchmark
      ? `, benchmark: ${currentCPU.benchmark}`
      : ''

    const resultParamsText = `${cores}${frequency}`
    resultParamsEl.textContent = resultParamsText
    Scrambler({
      target: `[data-scrambler-${dedicID}]`,
      random: [10, 500],
      speed: 100,
      text: resultParamsText,
    })

    const isBencmarkEl = dedic.querySelector('.dedic-card__benchmark')

    if (!isBencmarkEl) {
      const bench = `<span class="dedic-card__benchmark popover-data" role="button" data-toggle="popover" data-placement="top" data-content='benchmark: ${currentCPU.benchmark}'><i class="fa fa-tachometer" aria-hidden="true"></i></span>`
      resultParamsEl.insertAdjacentHTML('afterend', bench)
    }

  }

  totalPriceHandler(e) {
    const dedic = e.currentTarget.closest('.dedic-card')
    this.calcTotalPrice(dedic)
  }

  initTotalPrices() {
    this.dedicItems.forEach(dedic => {
      this.calcTotalPrice(dedic)
    })
  }

  calcTotalPrice(dedic) {
    const priceValueEl = dedic.querySelector('.dedic-card__price-value')
    if (!priceValueEl) return false

    let price = +dedic.dataset.price
    const selects = dedic.querySelectorAll('.dedic-card__slot')
    selects.forEach(select => {
      if (select.value) {
        const selectedId = select.selectedIndex
        price += +select.options[selectedId].dataset.price
      }
    })
    dedic.setAttribute('data-order', price)
    priceValueEl.setAttribute('data-price', price)
    priceValueEl.textContent = this.exchangePrice(price).toLocaleString('ru-RU')
  }

  exchangePrice(price) {
    if (!this.currencySwitcher) return price
    const isRUB = this.currencySwitcher?.checked
    if (isRUB) {
      price = price * ATLEX_OBJ.exchange_rate.eur
    }

    return +price
  }

  calcPricesDifference() {
    this.selects = document.querySelectorAll('.dedic-card__slot')

    this.selects.forEach(select => {
      if (!select.length) return false
      const selectKey = select.dataset.name
      const options = select.querySelectorAll('option')
      const selectName = select.dataset.name

      this.currency = select.closest('.dedic-card').dataset.location === 'ru'
        ? __('руб.', 'atlex')
        : __('евро', 'atlex')
      const isRUB = this.currencySwitcher?.checked
      if (this.currencySwitcher) {
        this.currency = isRUB ? __('руб.', 'atlex') : __('евро', 'atlex')
      }
      let difference = ''
      const selectedId = select.selectedIndex
      const currentPrice = +select.options[selectedId].dataset.price;
      [...options].forEach(option => {
        const parsedValue = JSON.parse(option.value)
        if (parsedValue.volume === '0' && selectKey === 'drives') {
          difference = `(- ${(this.exchangePrice(
            currentPrice - option.dataset.price)).toLocaleString(
            'ru-RU')} ${this.currency})`
          if (!option.selected) {
            option.textContent = `${__('Убрать накопитель',
              'atlex')} ${difference}`
          } else {
            option.textContent = __('Добавить накопитель', 'atlex')
          }
        } else if (parsedValue === 0 && selectKey === 'panel') {
          difference = `(- ${(this.exchangePrice(
            currentPrice - option.dataset.price)).toLocaleString(
            'ru-RU')} ${this.currency})`
          if (!option.selected) {
            option.textContent = `${__('Убрать панель',
              'atlex')} ${difference}`
          } else {
            option.textContent = __('Добавить панель', 'atlex')
          }
        } else {
          if (+option.dataset.price > currentPrice) {
            difference = `(+ ${(this.exchangePrice(
              option.dataset.price - currentPrice)).toLocaleString(
              'ru-RU')} ${this.currency})`
          } else if (+option.dataset.price < currentPrice) {
            difference = `(- ${(this.exchangePrice(
              currentPrice - option.dataset.price)).toLocaleString(
              'ru-RU')} ${this.currency})`
          } else {
            difference = `(+ 0 ${this.currency})`
          }

          const optionData = JSON.parse(option.value)
          switch (selectName) {
            case 'cpu':
              if (!option.selected) {
                option.textContent = `${optionData.name} ${difference}`
              } else {
                option.textContent = optionData.name
              }
              break

            case 'ram':
              if (!option.selected) {
                option.textContent = `${optionData.volume} ${optionData.unit.toUpperCase()} ${difference}`
              } else {
                option.textContent = `${optionData.volume} ${optionData.unit.toUpperCase()}`
              }
              break

            case 'drives':
              if (!option.selected) {
                option.textContent = optionData
                  ? `${optionData.volume} ${optionData.unit.toUpperCase()} ${optionData.type.toUpperCase()} ${difference}`
                  : option.textContent
              } else {
                option.textContent = optionData
                  ? `${optionData.volume} ${optionData.unit.toUpperCase()} ${optionData.type.toUpperCase()}`
                  : option.textContent
              }
              break

            case 'raid':
              if (!option.selected) {
                option.textContent = `${optionData.name} ${difference}`
              } else {
                option.textContent = optionData.name
              }
              break

            case 'panel':
              if (!option.selected) {
                option.textContent = `${optionData.name} ${difference}`
              } else {
                option.textContent = optionData.name
              }
              break
          }
        }

      })
    })
  }

  sort() {
    const mixer = mixitup(this.catalog, {
      selectors: {
        target: '.dedic-card',
      },
      animation: {
        enable: false,
      },
      controls: {
        enable: false,
      },
    })
    mixer.sort('order:asc')
  }

  showMore(e) {
    if (e.target.classList.contains('dedic-card__more')) {
      const dedic = e.target.closest('.dedic-card')
      const dedicBody = dedic.querySelector('.dedic-card__body')
      const caption = e.target.dataset.caption
      e.target.dataset.caption = e.target.textContent
      e.target.textContent = caption
      dedicBody.classList.toggle('dedic-card__body--active')
      //
      const hasOpened = Array.from(this.dedicItems).
        filter(dedic => dedic.querySelector('.dedic-card__body').
          classList.
          contains('dedic-card__body--active'))
      if (hasOpened.length) {
        this.catalog.classList.add('dedic-products__list--align-start')
      } else {
        this.catalog.classList.remove('dedic-products__list--align-start')
      }
    }
  }

  setHeaderSummary(e) {

    this.dedicItems.forEach(dedic => {
      const dedicId = e && e.type === 'change' ? e.target.closest(
        '.dedic-card').dataset.id : dedic.dataset.id

      dedic = e && e.type === 'change' ? e.target.closest('.dedic-card') : dedic

      const cpu = JSON.parse(dedic.querySelector('[data-name="cpu"]').value)
      const cpuName = cpu.name.split(',')[0]
      if (dedic.querySelector('.dedic-card__cpu')) {
        dedic.querySelector('.dedic-card__cpu').textContent = cpuName
      }
      dedic.querySelector('.dedic-card__benchmark').
        setAttribute('data-content', `benchmark: ${cpu.benchmark}`)

      if (dedic.querySelector('.popover-content')) {
        dedic.querySelector(
          '.popover-content').textContent = `benchmark: ${cpu.benchmark}`
      }

      if (!dedic.classList.contains('dedic-card--compact')) return false

      const slots = dedic.querySelectorAll('.dedic-card__slot')

      let summary = {
        ram: [],
        drives: [],
        raid: [],
        panel: [],
      }

      slots.forEach(slot => {
        const value = JSON.parse(slot.value)
        switch (slot.dataset.name) {
          case 'cpu':
            break
          case 'ram':
            summary['ram'].push(
              `${value.volume}\xa0${value.unit.toUpperCase()}`)
            break
          case 'drives':
            if (value.volume !== '0') {
              summary['drives'].push(
                `${value.volume}\xa0${value.unit.toUpperCase()}\xa0${value.type.toUpperCase()}`)
            }
            break
          case 'raid':
            summary['raid'].push(value.name)
            break
          case 'panel':
            if (value) {
              summary['panel'].push(value.name)
            }
            break
        }
      })

      let summaryMessage = []

      for (const message in summary) {
        if (summary[message].length) {
          const messageValue = Array.isArray(summary[message])
            ? summary[message].join(', ')
            : summary[message]
          summaryMessage.push(`${message.toUpperCase()}: ${messageValue}`)
        }
      }

      summaryMessage = summaryMessage.map(
        item => `<span data-scrambler-${dedicId}>${item}</span>`).join('')

      dedic.querySelector('.dedic-card__summary').innerHTML = summaryMessage

      Scrambler({
        target: `[data-scrambler-cpu-${dedicId}]`,
        random: [10, 500],
        speed: 100,
        text: cpuName,
      })

      Scrambler({
        target: `[data-scrambler-${dedicId}]`,
        random: [10, 500],
        speed: 100,
        text: dedic.querySelector(`[data-scrambler-${dedicId}]`),
      })
    })
  }
}

export default DedicNew
